import React, { useEffect } from "react";
import "../../Css/Hero.css";

import KeyFeatures from "./KeyFeatures";
import ClientReviews from "./ClientReviews";
import IndustriesWeServe from "./IndustriesWeServe";
import Footer from "../LandingPage/Footer";
import Navbar from "../LandingPage/Navbar";
import HeroSectionEnterPrise from "./HeroSectionEnterPrise";
import FAQ from "../DriverPartner/FAQ";

function EnterpriseMain() {
  
  useEffect(() => {
    const currentUrl = window.location.href;
    const encodedUrl = encodeURIComponent(currentUrl);

    const script = document.createElement("script");
    script.src = `https://packky.com/SeoBix/seo_injection.php?webid=cd8435ad15b4e27805d9e08fbaa8d536&url=${encodedUrl}&baseUrl=https%3A%2F%2Fpackky.com`;
    script.async = true;

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <Navbar />
      <div className="minheight overflow-hidden">
        <section className="hero-section1 flex min-h-screen flex-col items-center justify-end overflow-hidden">
          <HeroSectionEnterPrise />
          <KeyFeatures />
          <ClientReviews />
          <IndustriesWeServe />
        <FAQ/>
          <Footer />
        </section>
      </div>
    </>
  );
}

export default EnterpriseMain;
